import { request } from '../../src/utils/request';

export function getTagsAPI() {
  return request({
    url: '/api/get-tags',
    method: 'GET',
  });
}
export function updateTagAPI(tag, name) {
  return request({
    url: '/api/update-tag',
    method: 'POST',
    data: {
      tag,
      name,
    },
  });
}

export function addTagAPI(name) {
  return request({
    url: '/api/add-tag',
    method: 'POST',
    data: {
      name,
    },
  });
}

export async function deleteTagAPI(tag) {
  try {
    const response: any = await request({
      url: '/api/delete-tag',
      method: 'DELETE',
      params: {
        tag,
      },
    });

    // 检查响应数据是否包含成功消息
    if (response.message === 'タグが正常に削除されました') {
      return { status: true };
    } else {
      throw new Error(response.error || 'Failed to delete tag');
    }
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

// 获取保存的 Tokyo 结果
export function getTokyoResultAPI(): Promise<any> {
  return request({
    url: "/api/saveTokyoResult",
    method: "GET",
  });
}

// 保存 Tokyo 结果到 Redis
export async function saveTokyoResultAPI(data: any, timestamp?: number) {
  try {
    const response = await request({
      url: "/api/saveTokyoResult",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        data,
        timestamp: timestamp || Date.now(),
      },
    });

    const res: any = response;
    if (res.success) {
      return { success: true, timestamp: res.timestamp };
    } else {
      throw new Error(res.message || "保存失败");
    }
  } catch (error) {
    console.error("保存Tokyo结果失败:", error);
    throw error;
  }
}